// extracted by mini-css-extract-plugin
export default {"active_tab":"styles_active_tab__2NeVD","label":"styles_label__xmSNL","mg20":"styles_mg20__Km2DH","input":"styles_input__LFSzE"};